import { AdminLayout } from "../../layouts"
import { Grid, Paper, Typography, Link, Container } from '@mui/material';

import { Link as RouterLink } from "react-router-dom";
import { School, Group, People, LocationCity, LocalShipping } from "@mui/icons-material";

export const DashboardPage = () => {

    return (

        <AdminLayout title="Dashboard">

            <Container >
                <Grid container spacing={3} alignItems="center" mb={2} >
                    <Grid item xs={12}>
                        <Typography
                            sx={{ fontWeight: 500, fontSize: 40 }}
                        >
                            Portal de Administración
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{ fontWeight: 400, fontSize: 14 }}
                        >
                            Accede a todas las herramientas necesarias para gestionar la academia de manera eficaz
                        </Typography>
                    </Grid>

                    {/* Cursos */}
                    <Grid item xs={12} sm={3.5}>
                        <Paper
                            elevation={6}
                            sx={{
                                padding: 4,
                                borderRadius: 3,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <School sx={{ fontSize: 25 }} />
                            <Link
                                component={RouterLink}
                                to="/admin/cursos"
                                color={"text.primary"}
                                style={{ textDecoration: "none" }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, mb: 2 }}>
                                    Gestiona Cursos
                                </Typography>
                            </Link>
                            <Typography variant="body2" color="warning.main">
                                Crea y administra los cursos disponibles
                            </Typography>
                        </Paper>
                    </Grid>

                    {/* Grupos */}
                    <Grid item xs={12} sm={3.5}>
                        <Paper
                            elevation={6}
                            sx={{
                                padding: 4,
                                borderRadius: 3,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <Group sx={{ fontSize: 25 }} />
                            <Link
                                component={RouterLink}
                                to="/admin/grupos"
                                color={"text.primary"}
                                style={{ textDecoration: "none" }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, mb: 2 }}>
                                    Gestiona Grupos
                                </Typography>
                            </Link>
                            <Typography variant="body2" color="warning.main">
                                Organiza y visualiza los grupos de estudiantes
                            </Typography>
                        </Paper>
                    </Grid>

                    {/* Estudiantes */}
                    <Grid item xs={12} sm={3.5}>
                        <Paper
                            elevation={6}
                            sx={{
                                padding: 4,
                                borderRadius: 3,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <People sx={{ fontSize: 25 }} />
                            <Link
                                component={RouterLink}
                                to="/admin/estudiantes"
                                color={"text.primary"}
                                style={{ textDecoration: "none" }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, mb: 2 }}>
                                    Visualiza Estudiantes
                                </Typography>
                            </Link>
                            <Typography variant="body2" color="warning.main">
                                Observa y administra los datos de los estudiantes
                            </Typography>
                        </Paper>
                    </Grid>

                    {/* Colegios */}
                    <Grid item xs={12} sm={3.5}>
                        <Paper
                            elevation={6}
                            sx={{
                                padding: 4,
                                borderRadius: 3,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <LocationCity sx={{ fontSize: 25 }} />
                            <Link
                                component={RouterLink}
                                to="/admin/colegios"
                                color={"text.primary"}
                                style={{ textDecoration: "none" }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, mb: 2 }}>
                                    Gestiona Colegios
                                </Typography>
                            </Link>
                            <Typography variant="body2" color="warning.main">
                                Administra la información de los colegios asociados
                            </Typography>
                        </Paper>
                    </Grid>

                    {/* Sedes de Correos de Costa Rica */}
                    <Grid item xs={12} sm={3.5}>
                        <Paper
                            elevation={6}
                            sx={{
                                padding: 4,
                                borderRadius: 3,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <LocalShipping sx={{ fontSize: 25 }} />
                            <Link
                                component={RouterLink}
                                to="/admin/sedecorreoscr"
                                color={"text.primary"}
                                style={{ textDecoration: "none" }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, mb: 2 }}>
                                    Sedes de Correos
                                </Typography>
                            </Link>
                            <Typography variant="body2" color="warning.main">
                                Gestiona las sedes de correos de Costa Rica
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>



        </AdminLayout >

    )
}
